import { jsx as e } from "react/jsx-runtime";
import { withManagedProps as a } from "@made-people/managed-props";
import { withZod as s } from "@made-people/react-prop-guard";
import { blogTeaserSchema as o, BlogTeaser as m } from "@made-people/blueprint-blog-teaser";
import { swiperPropsSchema as l, Swiper as n } from "@made-people/blueprint-swiper";
const h = l.omit({
  children: !0
}), p = h.extend({
  items: o.array().optional(),
  blogPostVariants: o.shape.variants.optional()
}), b = a(
  "SwipeableBlogPosts",
  s(p, (t) => !t.items || t.items.length === 0 ? null : /* @__PURE__ */ e(n, { ...t, children: (t.items ?? []).map((i, r) => /* @__PURE__ */ e(
    m,
    {
      ...i,
      variants: t.blogPostVariants
    },
    `logo-item-${r}`
  )) }))
);
export {
  b as SwipeableBlogPosts,
  p as swipeableBlogPostsSchema
};
//# sourceMappingURL=index.es.js.map
